import classNames from 'classnames';
import { DefaultCardProps } from './default-card-props';
import { useDefaultCardStyles } from './default-card-styles';

export const DefaultCard = ({
  onClick,
  onCheck,
  isSelected,
  children,
  style,
  className,
  isClickable = true
}: DefaultCardProps) => {
  const classes = useDefaultCardStyles();

  return (
    <>
      <div
        onClick={onClick}
        className={classNames(
          classes.cardContainer,
          'card',
          isSelected ? classes.cardSelected : undefined,
          className,
          isClickable && classes.isClickable
        )}
        style={style}
      >
        {children}
      </div>
    </>
  );
};
